import { createAction } from '../../../store.model';
import { ActionType } from '../form.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ShowPublishConfirmDialog {}

export const showPublishConfirmDialog = createAction<
    ActionType,
    ShowPublishConfirmDialog
>(ActionType.EVAL_FORM__SHOW_PUBLISH_CONFIRM_DIALOG);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HidePublishConfirmDialog {}

export const hidePublishConfirmDialog = createAction<
    ActionType,
    HidePublishConfirmDialog
>(ActionType.EVAL_FORM__HIDE_PUBLISH_CONFIRM_DIALOG);
